import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
export var NsHighlightEdge;
(function (NsHighlightEdge) {
    NsHighlightEdge.command = XFlowEdgeCommands.HIGHLIGHT_EDGE;
    NsHighlightEdge.hookKey = 'highlightEdge';
})(NsHighlightEdge || (NsHighlightEdge = {}));
let HighlightEdgeCommand = class HighlightEdgeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.highlightEdge.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const x6Graph = yield this.ctx.getX6Graph();
                const { edgeId, strokeColor, strokeWidth } = handlerArgs;
                const allEdges = x6Graph.getEdges();
                /** 需要高亮的连线 */
                const highlightEdge = allEdges.find(edge => edge.id === edgeId);
                /** 不需要高亮的连线 */
                const otherEdges = allEdges.filter(edge => edge.id !== edgeId);
                if (!highlightEdge) {
                    console.error(edgeId, 'this edgeId is not exist');
                }
                else {
                    const oldAttr = highlightEdge.getAttrs();
                    if (((_a = oldAttr === null || oldAttr === void 0 ? void 0 : oldAttr.line) === null || _a === void 0 ? void 0 : _a.stroke) === strokeColor && ((_b = oldAttr === null || oldAttr === void 0 ? void 0 : oldAttr.line) === null || _b === void 0 ? void 0 : _b.strokeWidth) === strokeWidth) {
                        /** 连线已经高亮, 不需要重复操作 */
                    }
                    else {
                        /** 高亮选中的连线 */
                        highlightEdge === null || highlightEdge === void 0 ? void 0 : highlightEdge.setAttrs({
                            line: {
                                stroke: strokeColor,
                                strokeWidth: strokeWidth || 2,
                            },
                        });
                        /** 其余连线取消高亮状态 */
                        otherEdges.forEach(edge => {
                            edge.setAttrs({
                                line: oldAttr === null || oldAttr === void 0 ? void 0 : oldAttr.line,
                            });
                        });
                        /** 高亮的连线默认前置在画布最前方 */
                        handlerArgs.commandService.executeCommand(XFlowEdgeCommands.FRONT_EDGE.id, {
                            edgeId,
                        });
                    }
                }
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], HighlightEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HighlightEdgeCommand.prototype, "init", null);
HighlightEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsHighlightEdge.command.id },
    })
    /** 连线高亮 */
], HighlightEdgeCommand);
export { HighlightEdgeCommand };
//# sourceMappingURL=edge-highlight.js.map